import { createFileRoute, Outlet } from '@tanstack/react-router'

import { useFeatureFlag } from '@/hooks/useFeatureFlag'
import { AbsencesListView } from '@/modules/absences'
import { abscencesAllFilterSchema } from '@/modules/absences2'

const AbsenceRouteView = () => {
  const enabledAbsences2 = useFeatureFlag('IS_ABSENCES_2_0_MODULE_ENABLED')

  return enabledAbsences2 ? <Outlet /> : <AbsencesListView />
}

export const Route = createFileRoute('/_auth/absences')({
  component: AbsenceRouteView,
  validateSearch: abscencesAllFilterSchema
})
